import React from "react";
import { Row, Alert } from "react-bootstrap";
import Loader from "../../components/widgets/Loader.jsx";
import PropTypes from 'prop-types';
import { useStoreState } from "easy-peasy";

const RomesView = ({ romes, filteredRomes, view }) => {
    const { isFetchingAllRomes } = useStoreState(state => state.romes);

    return <Row>
        {isFetchingAllRomes
            ? <Loader />
            : romes?.length > 0
                ? filteredRomes?.length > 0
                    ? view
                    : <Alert className="mt-3" variant="warning">Aucun code ROME ne correspond à votre recherche</Alert>
                : <Alert className="mt-3" variant="warning">Vous n'avez accès à aucun code ROME</Alert>
        }
    </Row>;
}

RomesView.propTypes = {
    romes: PropTypes.array.isRequired,
    filteredRomes: PropTypes.array.isRequired,
    view: PropTypes.any.isRequired
};

export default RomesView;